import { render } from "./New_searchMaterial.vue?vue&type=template&id=79ce2d96"
import script from "./New_searchMaterial.vue?vue&type=script&lang=js"
export * from "./New_searchMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__